import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "003_purchase_suppliers",
  version: "1.2.0",
  ignoreErrors: ["no such table: accounting_partners"],
  sql: `
    CREATE TABLE IF NOT EXISTS \`purchase_suppliers\` (
      \`id\` text PRIMARY KEY NOT NULL,
      \`company_id\` text NOT NULL,
      \`partner_code\` text,
      \`partner_name\` text NOT NULL,
      \`is_customer\` integer DEFAULT 0 NOT NULL,
      \`is_supplier\` integer DEFAULT 1 NOT NULL,
      \`partner_entity_type\` text NOT NULL,
      \`tax_id\` text,
      \`id_card_number\` text,
      \`phone\` text,
      \`email\` text,
      \`address\` text,
      \`notes\` text,
      \`line_id\` text,
      \`credit_limit\` real DEFAULT 0,
      \`payment_term_days\` integer DEFAULT 30,
      \`bank_account_no\` text,
      \`bank_code\` text,
      \`bank_branch\` text,
      \`province\` text,
      \`district\` text,
      \`zip_code\` text,
      \`contact_person\` text,
      \`branch_no\` text,
      \`default_account_id\` text,
      \`default_price_list_id\` text,
      \`custom_data\` text,
      \`created_at\` text NOT NULL,
      \`created_by\` text,
      \`updated_at\` text NOT NULL,
      \`updated_by\` text,
      \`deleted_at\` text,
      \`deleted_by\` text
    );
    CREATE INDEX IF NOT EXISTS \`purchase_supplier_company_idx\` ON \`purchase_suppliers\` (\`company_id\`);
    CREATE INDEX IF NOT EXISTS \`purchase_supplier_company_supplier_idx\` ON \`purchase_suppliers\` (\`company_id\`, \`is_supplier\`);
    CREATE INDEX IF NOT EXISTS \`purchase_supplier_company_code_idx\` ON \`purchase_suppliers\` (\`company_id\`, \`partner_code\`);

    INSERT OR IGNORE INTO \`purchase_suppliers\` (
      \`id\`,
      \`company_id\`,
      \`partner_code\`,
      \`partner_name\`,
      \`is_customer\`,
      \`is_supplier\`,
      \`partner_entity_type\`,
      \`tax_id\`,
      \`id_card_number\`,
      \`phone\`,
      \`email\`,
      \`address\`,
      \`notes\`,
      \`line_id\`,
      \`credit_limit\`,
      \`payment_term_days\`,
      \`bank_account_no\`,
      \`bank_code\`,
      \`bank_branch\`,
      \`province\`,
      \`district\`,
      \`zip_code\`,
      \`contact_person\`,
      \`branch_no\`,
      \`default_account_id\`,
      \`default_price_list_id\`,
      \`custom_data\`,
      \`created_at\`,
      \`created_by\`,
      \`updated_at\`,
      \`updated_by\`,
      \`deleted_at\`,
      \`deleted_by\`
    )
    SELECT
      \`id\`,
      \`company_id\`,
      \`partner_code\`,
      \`partner_name\`,
      \`is_customer\`,
      \`is_supplier\`,
      \`partner_entity_type\`,
      \`tax_id\`,
      \`id_card_number\`,
      \`phone\`,
      \`email\`,
      \`address\`,
      \`notes\`,
      \`line_id\`,
      \`credit_limit\`,
      \`payment_term_days\`,
      \`bank_account_no\`,
      \`bank_code\`,
      \`bank_branch\`,
      \`province\`,
      \`district\`,
      \`zip_code\`,
      \`contact_person\`,
      \`branch_no\`,
      \`default_account_id\`,
      \`default_price_list_id\`,
      \`custom_data\`,
      \`created_at\`,
      \`created_by\`,
      \`updated_at\`,
      \`updated_by\`,
      \`deleted_at\`,
      \`deleted_by\`
    FROM \`accounting_partners\`
    WHERE \`is_supplier\` = 1;
  `,
};
